<section class="review-articles">

  <h3>Unsere <span>Community</span><br>spricht für sich</h3>

  <div class="slider">
    <swiper-container
      init="false"
      class="mySwiper"
    >
      <swiper-slide *ngFor="let post of posts">
        <div class="slide">
          <div class="description">
            <h4 itemprop="headline" [innerHTML]="post.title.rendered"></h4>
            <div [innerHTML]="decodeEntities(post.content.rendered)"></div>
          </div>
        </div>
      </swiper-slide>
    </swiper-container>
  </div>
</section>
